var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataLoaded)?_c('div',{staticClass:"dashboard-body-container"},[_c('ListItem',{attrs:{"items":_vm.items,"accessRights":_vm.accessRights,"title":_vm.$t('Deadline Approaching')}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }